module.exports = __webpack_public_path__ + "img/81.d33c1014.jpg";